import React, { useState } from 'react';

import { LinkContainer } from 'components/common/router';
import Routes from 'routing/Routes';
import { ButtonToolbar, Button } from 'components/bootstrap';
import { IfPermitted, ShareButton } from 'components/common';
import EntityShareModal from 'components/permissions/EntityShareModal';

import type Team from '../../logic/Team';

type Props = {
  team: Team | null | undefined;
};

const TeamActionLinks = ({ team }: Props) => {
  const [showShareModal, setShowShareModal] = useState<boolean>(false);

  if (!team) {
    return null;
  }

  return (
    <>
      <ButtonToolbar>
        <IfPermitted permissions={`team:read:${team.id}`}>
          <LinkContainer to={Routes.pluginRoute('SYSTEM_TEAMS_TEAMID')(team.id)}>
            <Button>View Details</Button>
          </LinkContainer>
        </IfPermitted>
        <IfPermitted
          permissions={[`team:edit:${team.id}`, `team_users:edit:${team.id}`, `team:rolesedit:${team.id}`]}
          anyPermissions>
          <LinkContainer to={Routes.pluginRoute('SYSTEM_TEAMS_TEAMID_EDIT')(team.id)}>
            <Button>Edit Team</Button>
          </LinkContainer>
        </IfPermitted>
        <ShareButton title="Manage" entityId={team.id} entityType="team" onClick={() => setShowShareModal(true)} />
      </ButtonToolbar>
      {showShareModal && (
        <EntityShareModal
          entityId={team.id}
          entityType="team"
          entityTitle={team.name}
          description="Search for a User or Team to add as collaborator on this Team."
          onClose={() => setShowShareModal(false)}
        />
      )}
    </>
  );
};

export default TeamActionLinks;
